import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/back-arrow-gray.svg'
import _imports_1 from '@/assets/product-info.png'
import _imports_2 from '@/assets/icons/success-modal.svg'


const _hoisted_1 = { class: "flex flex-col bg-background-secondary h-screen" }
const _hoisted_2 = { class: "flex flex-col bg-white" }
const _hoisted_3 = { class: "flex flex-row p-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"container flex flex-grow flex-col\"><div class=\"flex flex-row justify-between items-center\"><div class=\"flex flex-row items-center\"><div class=\"flex justify-center items-center bg-black text-blue-200 rounded h-10 w-10\"> S </div><span class=\"text-2xl font-semibold pl-4\">Management</span></div><button class=\"bg-primary text-white rounded-full py-4 px-8\"> Subscribe </button></div><div class=\"flex flex-col flex-grow justify-center py-16\"><span class=\"text-3xl font-semibold\"> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris vulputate qui </span><span class=\"pt-4\"> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris vulputate quis urna sit amet convallis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris vulputate quis urna sit amet convallis. </span></div></div>", 1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "container flex flex-row" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "w-1/2"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col justify-center pl-10 w-1/2" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-3xl font-semibold" }, "Lorem ipsum dolor sit amet, consectetur"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-xl pt-8" }, "Lorem ipsum dolor sit amet"),
    /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center pt-4" }, [
      /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
      /*#__PURE__*/_createElementVNode("span", { class: "pl-4" }, "Lorem ipsum dolor sit amet")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center pt-4" }, [
      /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
      /*#__PURE__*/_createElementVNode("span", { class: "pl-4" }, "Lorem ipsum dolor sit amet")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center pt-4" }, [
      /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
      /*#__PURE__*/_createElementVNode("span", { class: "pl-4" }, "Lorem ipsum dolor sit amet")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center pt-4" }, [
      /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
      /*#__PURE__*/_createElementVNode("span", { class: "pl-4" }, "Lorem ipsum dolor sit amet")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
        }, _hoisted_5)
      ]),
      _hoisted_6
    ]),
    _hoisted_7
  ]))
}